import React from 'react'

import { ChevronDoubleDownIcon, ChevronDoubleRightIcon } from '@heroicons/react/20/solid'
import Image from 'next/legacy/image'
import Link from 'next/link'

import { ManualApplicationDrawer } from './ManualApplicationDrawer'
import unlockLogo from '@/assets/img/unlock-logo.png'
import {
  setManualApplicationDrawerOpen,
  setManuallyCreateDealOpen,
  setShowWorkviewsFilters,
} from '@/client/generalSlice'
import { useAppDispatch, useAppSelector } from '@/client/hooks'

export function WQHeader() {
  const dispatch = useAppDispatch()
  const { showWorkviewsFilters } = useAppSelector((state) => state.general)

  const handleOpenManuallyDeal = () => {
    dispatch(setManuallyCreateDealOpen(true))
    dispatch(setManualApplicationDrawerOpen(true))
  }

  return (
    <>
      <header className='flex justify-between items-center gap-8 border-b px-8 bg-white shadow-sm sticky top-0 flex-wrap overflow-hidden'>
        <Link
          href={'/applications/'}
          passHref
          className='w-24 pt-2 pb-4'
        >
          <Image
            src={unlockLogo}
            alt='Unlock logo'
            objectFit='contain'
            height={88}
            width={256}
          />
        </Link>

        <div className='text-right'>
          <Link
            href='/logout'
            className='text-sm underline'
          >
            Logout
          </Link>
        </div>
      </header>
      <div className='flex gap-3 bg-gray-50 px-8 py-1 text-sm'>
        <span className='text-blue-800 font-semibold'>Pipeline</span>
        <span className='text-gray-300'>|</span>
        <span
          className='text-blue-800 font-semibold flex items-center gap-1'
          onClick={() => dispatch(setShowWorkviewsFilters(!showWorkviewsFilters))}
        >
          {showWorkviewsFilters ? 'Collapse' : 'Expand'} filters
          {showWorkviewsFilters ? (
            <ChevronDoubleDownIcon
              width={14}
              height={14}
            />
          ) : (
            <ChevronDoubleRightIcon
              width={14}
              height={14}
              data-test='expand-filters'
            />
          )}
        </span>
        <span className='text-gray-300'>|</span>
        <a
          className='hover:underline text-blue-800 cursor-pointer'
          data-test='workviews-manuallycreatemaxdeal-btn'
          onClick={handleOpenManuallyDeal}
        >
          Manually create a MAX Deal
        </a>
        <span className='text-gray-300'>|</span>
        <a
          className='hover:underline text-blue-800 cursor-pointer'
          href='/scenario-calculator'
          target='_blank'
          rel='noopener noreferrer'
        >
          Scenarios Calculator
        </a>
        <ManualApplicationDrawer />
      </div>
    </>
  )
}
